import {Button} from "../../../basic/button.tsx";
import {Check, Copy} from "lucide-react";
import {Input} from "../../../basic/input.tsx";
import {Label} from "../../../basic/label.tsx";
import {toast} from "sonner";
import {t} from "i18next";

interface InviteLinkDisplayProps {
    inviteCode: string;
    copied: boolean;
    onCopiedChange: (copied: boolean) => void;
}

export function InviteLinkDisplay({inviteCode, copied, onCopiedChange}: InviteLinkDisplayProps) {
    const copyToClipboard = async () => {
        const inviteLink = `${window.location.origin}/join?code=${inviteCode}`;
        try {
            await navigator.clipboard.writeText(inviteLink);
            onCopiedChange(true);
            toast.success(t('team.inviteLinkCopied'));
            setTimeout(() => onCopiedChange(false), 2000);
        } catch {
            toast.error(t('team.copyFailed'));
        }
    };

    return (
        <div className="space-y-2">
            <Label>{t('team.inviteLink')}</Label>
            <div className="flex gap-2">
                <Input
                    value={`${window.location.origin}/join?code=${inviteCode}`}
                    readOnly
                    className="font-mono flex-1"
                />
                <Button
                    variant="outline"
                    size="icon"
                    onClick={copyToClipboard}
                >
                    {copied ? <Check className="h-4 w-4 text-primary"/> : <Copy className="h-4 w-4"/>}
                </Button>
            </div>
            <p className="text-muted-foreground text-sm">
                {t('team.shareInviteLinkDescription')}
            </p>
        </div>
    );
}